import Widget, { IWidgetConsumer } from 'app/components/common/Widget';
import { WidgetNavigate } from 'app/components/common/WidgetNavigate';
import { useStore } from 'app/context';
import { LeadNowConvVM } from 'app/stores/ui/agt.leadnow.conv.ui.store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { LeadNowConversionFunnelChart } from './LeadNowConversionFunnelChart';

// Agt-dashboard variant of the LeadNow conversion widget. Where the home widget
// (LeadNowConversionWidget) aggregates the whole user scope into one funnel, this
// one shows the funnel for the single agt in focus (agenturUiStore.current) and
// overlays the user-scope aggregate as the "Durchschnitt" reference line, so the
// agt's conversion shape can be read against the rest. Both populations come from
// the same aggregateAgtsByKw call (cached), so no extra query is needed.
export const AgtLeadNowConversionWidget = observer((props: IWidgetConsumer) => {
	const { agtLeadNowConvUiStore, agenturUiStore } = useStore();
	const agt = agenturUiStore.current;

	const [agtItems, setAgtItems] = useState<LeadNowConvVM[]>([]);
	const [averageItems, setAverageItems] = useState<LeadNowConvVM[]>([]);

	useEffect(() => {
		if (!agt) {
			return;
		}
		agtLeadNowConvUiStore.load().then(() => {
			if (agtLeadNowConvUiStore.minKw && agtLeadNowConvUiStore.maxKw) {
				agtLeadNowConvUiStore.aggregateAgtsByKw(agtLeadNowConvUiStore.minKw, agtLeadNowConvUiStore.maxKw).then((all) => {
					setAverageItems(all);
					setAgtItems(all.filter((vm) => vm.agtId === agt.agtId));
				});
			}
		});
	}, [agtLeadNowConvUiStore, agt]);

	if (agtItems.length === 0) {
		return <></>;
	}

	return (
		<Widget title={'AMIS.Now Leads Abschlußquote'} action={<WidgetNavigate text={'Zum Bericht'} path={'/berichte/kunde/leadnow/conv/liste'} />} widgetId={props.widgetKey}>
			<LeadNowConversionFunnelChart items={agtItems} averageItems={averageItems} modifier="is-widget is-paddingless" height={125} />
		</Widget>
	);
});
